export default __webpack_public_path__ + "static/media/logo-nodle.75ba51c5.svg";